import {
  ChatBubbleOvalLeftEllipsisIcon,
  DocumentIcon,
  MicrophoneIcon,
  PencilSquareIcon,
  PhotoIcon,
  SpeakerWaveIcon,
} from '@heroicons/react/24/outline';

import { ArtifactType } from '@/services/types/artifact-digest-types';

interface ArtifactIconProps {
  type: ArtifactType;
  className?: string;
  isSelected?: boolean;
  /** When the artifact is a BLOB representing an image */
  isImage?: boolean;
}

export const ArtifactIcon = ({
  type,
  className = 'h-5 w-5',
  isSelected = false,
  isImage = false,
}: ArtifactIconProps) => {
  const baseClasses = `transition-colors ${className}`;
  const colorClasses = isSelected
    ? 'text-primary'
    : 'text-muted-foreground group-hover:text-foreground';

  const iconClasses = `${baseClasses} ${colorClasses}`;

  switch (type) {
    case ArtifactType.BLOB:
      return isImage ? (
        <PhotoIcon className={iconClasses} />
      ) : (
        <DocumentIcon className={iconClasses} />
      );
    case ArtifactType.DOCUMENT:
      return <DocumentIcon className={iconClasses} />;
    case ArtifactType.TRANSCRIPT:
      return <MicrophoneIcon className={iconClasses} />;
    case ArtifactType.AUDIO_CONVERSATION:
      return <SpeakerWaveIcon className={iconClasses} />;
    case ArtifactType.CONVERSATION:
      return <ChatBubbleOvalLeftEllipsisIcon className={iconClasses} />;
    case ArtifactType.STAFF_NOTE:
      return <PencilSquareIcon className={iconClasses} />;
    default:
      return <DocumentIcon className={iconClasses} />;
  }
};
